module.exports = __webpack_public_path__ + "static/media/batman-punch.c21bf51e.png";